import { render, staticRenderFns } from "./DialogDeniedReason.vue?vue&type=template&id=4160223f&scoped=true&"
import script from "./DialogDeniedReason.vue?vue&type=script&lang=js&"
export * from "./DialogDeniedReason.vue?vue&type=script&lang=js&"
import style0 from "./DialogDeniedReason.vue?vue&type=style&index=0&id=4160223f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160223f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VCard,VIcon})
